export default function ValueCreation() {
  const values = [
    {
      icon: 'ri-building-line',
      title: 'Company Building',
      description: 'We identify meaningful opportunities and help shape businesses around real market demand and long-term potential.',
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Strategic Positioning',
      description: 'We refine brand, product, and market positioning so each company can communicate clearly and compete effectively.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Operational Support',
      description: 'We strengthen execution through systems, structure, and disciplined decision-making.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Long-Term Growth',
      description: 'We support durable growth with patience, alignment, and a long-term view of value creation.',
    },
  ];

  return (
    <section className="py-36 bg-[#0A0F1E]">
      <div className="max-w-[1280px] mx-auto px-8">
        {/* Section Header */}
        <div className="mb-24">
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-[1px] bg-[#C9A96E]"></span>
            <p className="text-[11px] font-semibold tracking-[0.24em] uppercase text-[#C9A96E]">
              Value Creation
            </p>
          </div>
          <h2 className="text-[44px] lg:text-[52px] font-light text-white leading-[1.15] tracking-[-0.02em]">
            How Diivy <span className="font-semibold">creates value</span>
          </h2>
          <p className="text-[17px] text-white/60 leading-[1.8] font-light mt-6 max-w-[680px]">
            We do more than own companies. We help build them well.
          </p>
        </div>

        {/* Value Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {values.map((value, index) => (
            <div
              key={index}
              className="group p-10 border border-white/8 hover:border-[#C9A96E]/50 transition-all duration-500 cursor-default"
            >
              <div className="space-y-6">
                <div className="w-12 h-12 flex items-center justify-center border border-white/12 group-hover:border-[#C9A96E] group-hover:bg-[#C9A96E] transition-all duration-500">
                  <i className={`${value.icon} text-[20px] text-white/35 group-hover:text-[#0A0F1E] transition-colors duration-500`}></i>
                </div>

                <h3 className="text-[24px] font-light text-white group-hover:text-[#C9A96E] transition-colors duration-500 tracking-[-0.015em] leading-[1.3]">
                  {value.title}
                </h3>

                <p className="text-[15px] text-white/50 leading-[1.85] group-hover:text-white/70 transition-colors duration-500 font-light">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}